import React, { useState } from "react";

function EmbbedFormButton({ id, name }) {
  const [showPopUp, setShowPopUp] = useState(false);
  const [iframeCode, setIframeCode] = useState("");
  const [copied, setCopied] = useState(false);

  const handlePopUp = () => {
    setShowPopUp(!showPopUp);
  };

  const handleCopyCode = async () => {
    try {
      await navigator.clipboard.writeText(generateIframeCode());
      alert("Code copied to clipboard!");
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy code:", err);
    }
  };

  const generateIframeCode = () => {
    return `<iframe
      src="https://eventshub-be68d.web.app/${name.toLowerCase()
        .replace(/\s+/g, "-")}/form/${id}/view"
      width="100%"
      height="600"
      frameborder="0"
      >
    </iframe>`;
  };
  return (
    <div>
      {showPopUp && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-900 bg-opacity-50 flex justify-center items-center z-50 backdrop-blur-sm">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-2xl w-full mx-4">
            <h3 className="text-lg font-medium mb-4">Code to embed the form</h3>
            <div className="bg-gray-100 p-4 rounded overflow-auto max-h-96">
              <pre className="text-sm">{iframeCode}</pre>
            </div>
            <div className="mt-4 flex justify-between gap-3">
              <button
                onClick={handleCopyCode}
                className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition-colors duration-200 flex items-center"
              >
                Copy
              </button>
              <button
                onClick={handlePopUp}
                className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 transition-colors duration-200 flex items-center"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      <button
        onClick={() => {
          handlePopUp();

          setIframeCode(generateIframeCode());
        }}
        className="bg-blue-500 text-white px-5 py-4 rounded-lg hover:bg-blue-600"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-copy" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"/>
</svg>
      </button>
    </div>
  );
}
export default EmbbedFormButton;
